const config = {
  BASE_URI: process.env.REACT_APP_API_URI,
  CAPTCHA_SITE_KEY : process.env.REACT_APP_CAPTCHA_SITE_KEY
};

export default config;
